import { LS03_PLASMIC_PROPS } from "@stadium/shared/src/components/plasmic/LS03/plasmic-props";

import {
  LOGO_STRIPS_VARIANTS,
  L_03 as LOGO_STRIPS_L03,
} from "@stadium/shared/src/helpers/plasmic/static-slices";

export const LOGO_STRIPS_PLASMIC_PROPS = {
  variant: {
    type: "choice",
    options: LOGO_STRIPS_VARIANTS,
    defaultValue: LOGO_STRIPS_L03,
    description: "Select logo strips variant",
  },
  ...LS03_PLASMIC_PROPS,

  backgroundColor: {
    type: "string",
    defaultValue: "#f9f9f9",
    description: "Background color for content area",
  },
  className: {
    type: "string",
    defaultValue: "",
  },
};
